<template>
  <zpa-form-item
    :error="error"
    :success="success"
    :validating="validating"
    :required="required"
    :readonly="readonly"
    :disabled="disabled"
    :uuid="uuid"
    :span="span"
    :push="push"
    :label="showLabel?label:''"
    :labelWidth="labelWidth"
    :labelAlign="labelAlign"
    :itemHeight="itemHeight"
  >
    <editor-bar
      :value="value"
      :placeholder="placeholder || label"
      :readonly="readonly"
      :disabled="disabled"
      @change="onInputChange"
      style="z-index:99;"
    ></editor-bar>

  </zpa-form-item>
</template>

<script>
import inputMixin from './mixins/input';
import EditorBar from '@/components/commons/WangEditor'
export default {
  name: 'zpaTextEditor',

  mixins: [inputMixin],
  components: {
    EditorBar,
  },
  props: {
    type: String,
    value: {
      type: String,
      default: ''
    }
  },
  watch: {
    value(val, old) {
      if (old === undefined || old === '') { // 处理因为异步请求数据导致的验证报错
        this.debounceValidate()
      }
    }
  }
}
</script>
